<!-- @if (singleRow) { -->
<div class="m-0 p-0 d-flex {{ singleRow ? 'flex-row' : 'flex-column' }} {{ smallCaps ? 'small fst-italic' : '' }} {{ textAlign === 'CENTER' ? 'justify-content-center' : textAlign === 'RIGHT' ? 'justify-content-end' : 'justify-content-start' }} {{ textColor != ''  ? textColor : '' }}">
    @if (type === 'ICON') {
    <i
        class="fs-4 m-0 p-0 {{ value != ''  ? value : 'bi bi-three-dots' }}"></i>
    }
    @else if (type === 'DATE') {
    <p class="m-0 p-0">
        {{ caption }} {{ value === '' ? '&nbsp;' : value | date:'medium' }}
    </p>
    }
    @else if (type === 'LOG') {
    <p class="m-0 p-0">
        {{ value === '' ? '&nbsp;' : value | date:'medium' }}</p>
    } @else if (type === 'NUMBER') {
    <p class="m-0 p-0">
        {{ value === '' ? '&nbsp;' : value | number }}</p>
    } @else if (type === 'LINK') {
    <p class="m-0 p-0">
        <i class="bi bi-link {{ value === '' ? 'd-none' : 'me-1' }}"></i>
        <a class="text-decoration-none" target="_blank" href="{{ value === '' ? '#' : value }}">{{ value }}</a>
    </p>
    } @else if (type === 'EMAIL') {
    <p class="m-0 p-0">
        <i class="bi bi-envelope-at border-primary-subtle {{ value === '' ? 'd-none' : 'me-1' }}"></i>
        <a class="text-decoration-none" target="_blank" href="{{ value === '' ? '#' : 'mailto:' + value }}">{{ value }}</a>
    </p>
    } @else if (type === 'PHONE') {
    <p class="m-0 p-0">
        <i class="bi bi-telephone {{ value === '' ? 'd-none' : 'me-1' }}"></i>
        <a class="text-decoration-none" target="_blank" href="{{ value === '' ? '#' : 'tel:' + value }}">{{ value }}</a>
    </p>
    } @else if (type === 'IMAGE') {
        <img src="{{ value != '' ? value : baseURL + '/storage/default/user.png' }}" class="object-fit-cover border rounded-circle p-1"
        style="height: 4rem !important; width: 4rem !important;" />
    } @else {
    <p class="m-0 p-0">
        {{ value }}</p>
    }
</div>